<template>
  <ms-dynamic-popup
    :maximum="true"
    :esc-to-close="escToClose"
    :title="titleVoucher"
    classTitle="budget-plan-with-draw-detail"
    @beforeOpen="beforeOpen($event, close)"
    @beforeClose="beforeClose"
    classDetail="plan-with-draw-cash-detail"
    class="bu-plan-with-draw-cash-detail"
    @shortkeyAction="shortkeyAction"
  >
    <template v-slot:icon>
      <ms-button
        text="Hướng dẫn"
        type="icon-button"
        class="btn-guide step-1"
        leftIcon="ic-guide"
        @click="guide"
        tooltipIconLeft="Hướng dẫn chức năng"
      />
      <ms-button
        text="Phím tắt"
        tooltipIconLeft="Phím tắt"
        type="icon-button"
        class="btn-guide step-2"
        leftIcon="ic-shortkey"
        @click="clickShortkeyBtn"
      />

      <ms-tour :steps="stepsDynamic" v-model:open="showStep" container=".plan-with-draw-cash-detail"></ms-tour>

      <div
        class="button icon24 setting-small mr-2 step-3"
        v-tooltip="'Tùy chỉnh giao diện'"
        shortkey-target="ConfigLayout"
        @click="clickSettingLayout"
      ></div>
      <div class="button icon24 email mr-2" v-tooltip="'Email'"></div>

      <a target="_blank" :href="linkHelp($ms.constant.Help.CAPlanWithDraw)">
        <div class="button icon24 ic-question mr-2 step-4" v-tooltip="'Trợ giúp'" shortkey-target="Help"></div>
      </a>
    </template>

    <template v-slot:content>
      <div class="h-100 flex-column popup-container">
        <div class="central-title-radio" :class="{'pt-1': !toggleAbove}">
          <div>
            <ms-radio
              label="Tạm ứng đã cấp dự toán"
              name="rdnameCash"
              :disabled="viewing"
              :keyValue="2"
              v-model="model.cash_withdraw_type_id"
              @msChange="changeRadioType"
              class="mr-4"
            />
            <ms-radio
              label="Tạm ứng chưa cấp dự toán"
              name="rdnameCash"
              :keyValue="3"
              :disabled="viewing"
              v-model="model.cash_withdraw_type_id"
              @msChange="changeRadioType"
              class="mr-4"
            />
            <ms-radio
              label="Thực chi"
              name="rdnameCash"
              :keyValue="6"
              :disabled="viewing"
              class="mr-4"
              v-model="model.cash_withdraw_type_id"
              @msChange="changeRadioType"
            />
          </div>
        </div>
        <div class="central-title">
          <div class="title-control-group" @click="toggleAboveHandler">Thông tin chung</div>
          <div class="amount-total">
            <div class="amount-text">Tổng tiền</div>
            <div class="amount-value">
              {{
                $ms.format.formatData(totalAmountComputed, {
                  formatType: $ms.constant.FormatType.Amount,
                })
              }}
            </div>
          </div>
        </div>
        <!-- Bên trên -->
        <div class="above-container flex-row" v-show="toggleAbove">
          <div class="above-left flex">
            <div class="flex-row control-group">
              <div class="flex-row flex1">
                <div class="control-title" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                  <label title="Chương trình mục tiêu">CTMT</label>
                </div>
                <div class="control-right" v-if="offlineReady">
                  <ms-combobox
                    quickAdd="TargetProgramDetail"
                    class="flex"
                    valueField="project_id"
                    displayField="project_code"
                    :disabled="viewing"
                    v-model="model.project_id"
                    v-model:display="model.project_code"
                    @selected="
                      ({newData}) => {
                        selectedProject({newData}, this);
                      }
                    "
                    :initText="model.project_code"
                    :data="projectCombo"
                    :columns="projectColumns"
                    :dropdownWidth="600"
                    @submitQuickAdd="payload => submitQuickAdd(payload, comboboxDataRemote, 'project')"
                    quickSearch="ProjectQuickSearch"
                    :quickSearchParam="quickSearchParam.Project"
                  ></ms-combobox>
                </div>
                <div class="control-right" v-if="!offlineReady">
                  <ms-combobox
                    quickAdd="TargetProgramDetail"
                    class="flex"
                    valueField="project_id"
                    displayField="project_code"
                    :disabled="viewing"
                    v-model="model.project_id"
                    v-model:display="model.project_code"
                    @selected="
                      ({newData}) => {
                        selectedProject({newData}, this);
                      }
                    "
                    :initText="model.project_code"
                    :data="comboboxDataRemote.project"
                    :columns="projectColumns"
                    :dropdownWidth="600"
                    @submitQuickAdd="payload => submitQuickAdd(payload, comboboxDataRemote, 'project')"
                    :queryMode="'remote'"
                    quickSearch="ProjectQuickSearch"
                    :quickSearchParam="quickSearchParam.Project"
                    :remoteFilter="true"
                    @comboboxLoadData="
                      payload =>
                        onProjectCommonComboboxLoadData(payload, null, {
                          dataField: 'project',
                        })
                    "
                  ></ms-combobox>
                </div>
              </div>
              <ms-input class="flex2 ml-2" disabled v-model="model.project_name"></ms-input>
            </div>
            <div class="flex-row control-group">
              <div class="flex-row flex1">
                <div class="control-title" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                  <label title="Tài khoản số">Tài khoản số</label>
                </div>
                <div class="control-right" v-if="offlineReady">
                  <ms-combobox
                    quickAdd="BankInfoDetail"
                    class="flex"
                    valueField="bank_info_id"
                    displayField="bank_account"
                    v-model="model.bank_info_id"
                    v-model:display="model.bank_account"
                    :initText="model.bank_account"
                    :data="bankInfoCombo"
                    :columns="bankColumns"
                    @selected="
                      ({newData}) => {
                        selectedBankBUPlan({newData}, this);
                      }
                    "
                    @submitQuickAdd="payload => submitQuickAdd(payload, comboboxDataRemote, 'bank')"
                    quickSearch="BankInfoQuickSearch"
                    :disabled="viewing"
                    :dropdownWidth="600"
                  ></ms-combobox>
                </div>
                <div class="control-right" v-if="!offlineReady">
                  <ms-combobox
                    quickAdd="BankInfoDetail"
                    class="flex"
                    valueField="bank_info_id"
                    displayField="bank_account"
                    v-model="model.bank_info_id"
                    v-model:display="model.bank_account"
                    :initText="model.bank_account"
                    :data="comboboxDataRemote.bank"
                    :columns="bankColumns"
                    @selected="
                      ({newData}) => {
                        selectedBankBUPlan({newData}, this);
                      }
                    "
                    @submitQuickAdd="payload => submitQuickAdd(payload, comboboxDataRemote, 'bank')"
                    :queryMode="'remote'"
                    quickSearch="BankInfoQuickSearch"
                    :remoteFilter="true"
                    @comboboxLoadData="
                      payload =>
                        onBankInfoComboboxLoadData(payload, null, {
                          dataField: 'bank',
                        })
                    "
                    :disabled="viewing"
                    :dropdownWidth="600"
                  ></ms-combobox>
                </div>
              </div>
              <ms-input class="flex2 ml-2" :disabled="viewing" v-model="model.bank_name" :maxLength="255"></ms-input>
            </div>

            <div class="flex-row control-group">
              <div class="flex-row flex1 step-1">
                <div class="control-title" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                  <label title="Người lĩnh tiền">Người lĩnh tiền</label>
                </div>
                <div class="control-right" v-if="offlineReady">
                  <ms-combobox
                    :quickAddMulti="quickAddMultiItems"
                    class="flex"
                    valueField="accounting_object_id"
                    displayField="accounting_object_code"
                    v-model="model.accounting_object_id"
                    v-model:display="model.accounting_object_code"
                    @selected="
                      ({newData}) => {
                        selectedAccountingObjectBUPlanWidthDraw({newData}, this);
                      }
                    "
                    :initText="model.accounting_object_code"
                    :disabled="viewing"
                    :dropdownWidth="600"
                    :data="accountingObjectCombo"
                    :columns="accountColumns"
                    @submitQuickAdd="payload => submitQuickAdd(payload, comboboxDataRemote, 'account')"
                    quickSearch="RemoteQuickSearchPopup"
                    :quickSearchParam="quickSearchParam.AccountingObject"
                  ></ms-combobox>
                </div>
                <div class="control-right" v-if="!offlineReady">
                  <ms-combobox
                    :quickAddMulti="quickAddMultiItems"
                    class="flex"
                    valueField="accounting_object_id"
                    displayField="accounting_object_code"
                    v-model="model.accounting_object_id"
                    v-model:display="model.accounting_object_code"
                    @selected="
                      ({newData}) => {
                        selectedAccountingObjectBUPlanWidthDraw({newData}, this);
                      }
                    "
                    :initText="model.accounting_object_code"
                    :disabled="viewing"
                    :dropdownWidth="600"
                    :data="comboboxDataRemote.account"
                    :columns="accountColumns"
                    @submitQuickAdd="payload => submitQuickAdd(payload, comboboxDataRemote, 'account')"
                    :queryMode="'remote'"
                    quickSearch="RemoteQuickSearchPopup"
                    :quickSearchParam="quickSearchParam.AccountingObject"
                    :remoteFilter="true"
                    @comboboxLoadData="
                      payload =>
                        onAccountingObjectComboboxLoadData(payload, null, {
                          dataField: 'account',
                        })
                    "
                  ></ms-combobox>
                </div>
              </div>

              <ms-input
                class="flex2 ml-2"
                :disabled="viewing"
                v-model="model.accounting_object_name"
                :maxLength="255"
              ></ms-input>
            </div>

            <div class="flex-row control-group">
              <div class="control-title" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Diễn giải">Diễn giải</label>
              </div>
              <div class="control-right">
                <ms-input v-model="model.journal_memo" :disabled="viewing" :maxLength="240"></ms-input>
              </div>
            </div>
          </div>
          <div class="above-right">
            <div class="seperator-line"></div>
            <div class="flex-row control-group mt-1">
              <div class="control-title-right" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Ngày chứng từ">Ngày CT</label>
              </div>
              <div class="w-205px">
                <ms-datepicker
                  class="flex2"
                  v-model="model.ref_date"
                  :tooltipIcon="'Chọn ngày tháng'"
                  :disabled="viewing"
                  :rules="[{name: $ms.constant.ValidateRule.Required}]"
                  @onBlurActionDatePicker="onBlurActionDatePicker(this)"
                />
              </div>
            </div>
            <div class="flex-row control-group">
              <div class="control-title-right" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Ngày hạch toán">Ngày HT</label>
              </div>
              <div class="w-205px">
                <ms-datepicker
                  class="flex2"
                  v-model="model.posted_date"
                  :tooltipIcon="'Chọn ngày tháng'"
                  :disabled="viewing"
                  :rules="[{name: $ms.constant.ValidateRule.Required}]"
                />
              </div>
            </div>
            <div class="flex-row control-group">
              <div class="control-title-right" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Số chứng từ">Số CT</label>
              </div>
              <div class="w-205px">
                <ms-input
                  class="flex2"
                  v-model="model.ref_no"
                  :maxLength="20"
                  :rules="[{name: $ms.constant.ValidateRule.Required}]"
                  :disabled="viewing"
                />
              </div>
            </div>
            <div class="flex-row control-group">
              <div class="control-title-right" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Số cam kết chi">Số CKC</label>
              </div>
              <div class="w-205px">
                <ms-input
                  class="flex2"
                  v-model="model.bu_commitment_request_ref_no"
                  :maxLength="20"
                  :disabled="viewing"
                  rightIcon="option-tab"
                  :isClickRightIcon="true"
                  @clickRightIcon="onClickCKC(this)"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- Bên dưới -->
        <div class="flex1 under-container flex-column">
          <button
            class="toggle-above icon24"
            :class="{expand: toggleAbove}"
            :tabindex="-1"
            @click="toggleAboveHandler"
            v-if="!toggleAbove"
            v-tooltip="'Mở rộng'"
          ></button>
          <button
            class="toggle-above icon24"
            :class="{expand: toggleAbove}"
            :tabindex="-1"
            @click="toggleAboveHandler"
            v-if="toggleAbove"
            v-tooltip="'Thu nhỏ'"
          ></button>
          <div class="toolbar-grid flex-between">
            <div class="item-tabs active">Chi tiết</div>
            <div class="flex-row flex-center">
              <label class="label text-nowrap">Loại tiền</label>

              <div class="ml-2 w100px">
                <ms-combobox
                  :columns="currencyColumns"
                  valueField="currency_code"
                  displayField="currency_code"
                  ref="refCurrencyCode"
                  :data="comboboxDataRemote.currency"
                  v-model="model.currency_code"
                  :initText="model.currency_code"
                  @selected="selectCurrency"
                  @blur="assignValueCurrency"
                  :dropdownWidth="600"
                  :class="['input-editor', 'currency-combo']"
                  :queryMode="'remote'"
                  :remoteFilter="true"
                  @comboboxLoadData="onCurrencyComboboxLoadData"
                  :disabled="viewing"
                ></ms-combobox>
              </div>

              <label
                class="text-nowrap ml-2"
                v-show="model.currency_code != $t('i18nEnum.Currency.VND') && model.currency_code"
                >Tỷ giá</label
              >

              <div
                class="ml-2 w100px"
                v-show="model.currency_code != $t('i18nEnum.Currency.VND') && model.currency_code"
              >
                <ms-number
                  v-model="model.exchange_rate"
                  :formatType="$ms.constant.FormatType.ExchangeRate"
                  :disabled="viewing"
                  @onActionBlur="onActionBlur"
                ></ms-number>
              </div>
            </div>
          </div>
          <div class="grid-container">
            <ms-grid-editor
              formId="bu-plan-with-draw-cash-detail"
              :data="model.BuPlanWithDrawDetails"
              :ref="refDetail"
              class="flex-box"
              v-model:list="model.BuPlanWithDrawDetails"
              idField="ref_detail_id"
              greyTitle
              @submitQuickAdd="() => onSubmitQuickAdd(...argurments, comboboxDataRemote)"
              :propsData="propsData"
              :footer="true"
              :disabled="viewing"
              @updateBusiness="changeDataBusiness"
              @resizeStop="onResizeStop"
              :changeTriggers="changeTriggers"
              @onEditEventCellEditor="
                (colIndex, rowIndex, $grid) => {
                  toggleAboveHandlerGrid(colIndex, rowIndex, $grid, this);
                }
              "
              :lockable="false"
              @copyDownRow="copyDownRow"
              @copyActionClick="copyActionClick"
              isCopyDataColumn
              multipleErrorField
              :lineBreak="this.dbOptions?.LineBreak ?? 1"
              :itemRightClicks="itemRightClicks"
            ></ms-grid-editor>
          </div>
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="h-100 flex-between flex1" style="flex-direction: row-reverse">
        <div>
          <div class="flex-row" v-if="!viewing" style="flex-direction: row-reverse">
            <ms-button
              text="Cất"
              v-tooltip="'Cất (Ctrl + S)'"
              class="step-close"
              shortkey-target="Save"
              @click="commandClick($ms.constant.Command.SaveView)"
            ></ms-button>

            <ms-button
              text="Hoãn"
              type="btn-custom"
              class="mr-footer-btn"
              v-tooltip="'Hoãn (Ctrl + U)'"
              shortkey-target="Postpone"
              v-if="!viewing"
              @click="commandClick($ms.constant.Command.Postpone)"
            ></ms-button>
          </div>

          <div class="flex-row" v-if="viewing">
            <ms-button
              text="Sửa"
              @click="onEditEvent"
              class="step-close"
              v-tooltip="'Sửa (Ctrl + E)'"
              shortkey-target="Edit"
              v-if="this.isShowEditAndPosted && !this.isFromCompareConvert"
              :disabled="offlineReady"
            ></ms-button>
          </div>
        </div>

        <div class="flex-row flex-center" v-if="!this.isFromCompareConvert">
          <ms-button
            leftIcon="refresh-white-big"
            type="btn-footer-helpful"
            text="Nạp"
            @click="refresh"
            v-tooltip="'Nạp (Ctrl + R)'"
            shortkey-target="Refresh"
            :disabled="this.editMode != this.$ms.constant.FormState.View"
            class="btn-opacity max-height pl-1"
            v-show="this.isShowRefreshAndApprove"
          ></ms-button>
          <div class="seperator-button" v-show="this.isShowRefreshAndApprove"></div>

          <ms-drop-down-button
            leftIcon="utilities-white-big"
            type="secondary-outline"
            text="Tiện ích"
            class="max-height step-5-save"
            classCustom="btn-opacity"
            @menuClick="clickItemHandle"
            :menuItems="buttonUtilities"
            isBtnFooterHelpFul
            :byDateClose="!this.isShowRefreshAndApprove"
          ></ms-drop-down-button>

          <div class="seperator-button"></div>

          <ms-drop-down-button
            leftIcon="print-white-big"
            type="secondary-outline"
            text="In"
            :isBtnPrint="true"
            @printPreviousReport="printPreviousReport"
            v-tooltip="'In'"
            class="max-height step-6-save"
            classCustom="btn-opacity"
            :disabled="!viewing"
            :menuItems="printMenu"
            @menuClick="printItemCLick"
            :maxHeight="$t('i18nNumber.maxPrintHeight')"
            isBtnFooterHelpFul
          ></ms-drop-down-button>

          <div class="seperator-button" v-show="this.isShowRefreshAndApprove"></div>

          <ms-button
            leftIcon="approve-white-big"
            type="btn-footer-helpful"
            text="Duyệt"
            shortkey-target="Approve"
            class="btn-opacity max-height"
            :disabled="!viewing || isShowFromReport || stateApprove"
            @click="onApproveAction"
            v-show="this.isShowRefreshAndApprove"
          ></ms-button>
          <div class="seperator-button"></div>

          <ms-button
            leftIcon="ic-delete-voucher"
            type="btn-footer-helpful"
            text="Xóa"
            shortkey-target="Delete"
            class="btn-opacity max-height step-7-save"
            v-tooltip="'Xóa (Ctrl + D)'"
            :disabled="disabledDelete"
            @click="clickItemHandle({command: $ms.constant.Command.Delete})"
          ></ms-button>
          <button
            shortkey-target="Add"
            @click="clickItemHandle({command: $ms.constant.Command.Add})"
            class="d-none"
            v-if="viewing"
          ></button>
          <button
            shortkey-target="Duplicate"
            @click="clickItemHandle({command: $ms.constant.Command.Duplicate})"
            class="d-none"
            v-if="viewing"
          ></button>
          <button
            shortkey-target="CopyVoucher"
            @click="clickItemHandle({command: $ms.constant.Command.Copy})"
            class="d-none"
            v-if="!viewing"
          ></button>
          <button
            shortkey-target="ViewAccount"
            @click="clickItemHandle({command: $ms.constant.Command.ViewAccount})"
            class="d-none"
          ></button>
          <button
            shortkey-target="Delete"
            @click="clickItemHandle({command: $ms.constant.Command.Delete})"
            class="d-none"
            v-if="viewing && !model.is_posted && this.isShowRefreshAndApprove"
          ></button>
        </div>

        <div class="flex-row">
          <ms-button
            type="btn-custom"
            v-if="viewing && this.isShowRefreshAndApprove && !this.isFromCompareConvert"
            leftIcon="left-arrow-white"
            class="mr-1"
            shortkey-target="ArrowLeft"
            :disabled="!currentIndexBack"
            v-tooltip="'Trước'"
            @click="commandClick($ms.constant.Command.BackVoucher)"
          ></ms-button>
          <ms-button
            type="btn-custom"
            v-if="viewing && this.isShowRefreshAndApprove && !this.isFromCompareConvert"
            shortkey-target="ArrowRight"
            leftIcon="right-arrow-white"
            :disabled="!currentIndexNext"
            v-tooltip="'Sau'"
            @click="commandClick($ms.constant.Command.NextVoucher)"
            class="mr-1"
          ></ms-button>
          <ms-button text="Đóng" type="btn-custom" class="mr-2" @click="hide()" shortkey-target="Quit"></ms-button>
        </div>
      </div>
    </template>
  </ms-dynamic-popup>
</template>

<script>
import msDynamicPopup from '@/components/popup/MsDynamicPopup.vue';
import msGridEditor from '@/components/gridEditor/MsGridEditor.vue';
import baseDetailVoucher from '@/views/base/baseDetailVoucher';
import {ModuleBuPlanWithDraw, ModuleCAReceipt} from '@/stores/moduleConst';
import popupUtil from '@/commons/popupUtil';

import cAReceiptAPI from '@/apis/ca/cAReceiptAPI.js';
import {showConfirm, showConfirmWithDontShowAgain} from '@/commons/globalMessage';
import {ModuleContext} from '@/stores/moduleConst';
import {mapGetters} from 'vuex';

import {reactive, ref, getCurrentInstance, onMounted, computed, shallowRef} from 'vue';
import moment from 'moment';
import {useBUPlanWithdrawDetailDataCommon} from './BUPlanWithdrawDetailDataCommon.js';
import {useBUPlanWithdrawCashDetailData} from './BUPlanWithdrawCashDetailData.js';
import {useComboboxColumns} from '@/commons/combobox/comboboxColumns';
import {useCurrencyCombo} from '@/commons/combobox/CurrencyCombo.js';
import {useInitActionCombo} from '../../../commons/combobox/initActionCombo.js';
import {useActionGridEditor} from '@/commons/gridColumn/ActionGridEditor.js';
import {useInforCommons} from '../../utility/commons/inforCommons.js';
import {useQuickAccountingVoucher} from '@/setup/utilities/quickAccountingVoucher.js';
import RefType from '@/commons/wildcards/constants/RefType.js';
import stateBankAPI from '@/apis/di/stateBankAPI.js';
import {usefilterActionCombo} from '@/commons/combobox/filterActionCombo.js';
import {useBUPlanWithdrawCommon} from './BUPlanWithdrawCommon.js';
import store from '@/stores/store';
import {ModuleDbOption} from '@/stores/moduleConst';
import commonFunction from '@/commons/commonFunction.js';

import {useCacheAccountComboConfig} from '@/commons/combobox/cacheCombo/cacheAccountComboConfig.js';
import {useCacheBudgetSourceComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetSourceComboConfig.js';
import {useCacheBudgetChapterComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetChapterComboConfig.js';
import {useCacheBudgetKindItemComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetKindItemComboConfig.js';
import {useCacheBudgetItemComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetItemComboConfig.js';
import {useCacheProjectComboConfig} from '@/commons/combobox/cacheCombo/cacheProjectComboConfig.js';
import {useCacheAccountingObjectComboConfig} from '@/commons/combobox/cacheCombo/cacheAccountingObjectComboConfig.js';
import {useCacheActivityComboConfig} from '@/commons/combobox/cacheCombo/cacheActivityComboConfig.js';
import {useCacheStatisticComboConfig} from '@/commons/combobox/cacheCombo/cacheStatisticComboConfig.js';
import {useCacheBankInfoComboConfig} from '@/commons/combobox/cacheCombo/cacheBankInfoComboConfig.js';
import {useCacheContractComboConfig} from '@/commons/combobox/cacheCombo/cacheContractComboConfig.js';
import {useCacheTopicComboConfig} from '@/commons/combobox/cacheCombo/cacheTopicComboConfig.js';
import {useCacheTaskComboConfig} from '@/commons/combobox/cacheCombo/cacheTaskComboConfig.js';
import {useCacheBudgetProvideComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetProvideComboConfig.js';
import {useCacheFundStructureComboConfig} from '@/commons/combobox/cacheCombo/cacheFundStructureComboConfig.js';
import {useCacheFundComboConfig} from '@/commons/combobox/cacheCombo/cacheFundComboConfig.js';
import {useCacheBudgetFeesComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetFeesComboConfig.js';
import MsTour from '@/components/tour/MsTour.vue';
import buPlanWithDrawAPI from '@/apis/bu/buPlanWithDrawAPI.js';
import {ModuleOfflineWork} from '@/stores/moduleConst';
import CashWithDrawType from '@/commons/wildcards/constants/CashWithDrawType.js';

export default {
  components: {
    msDynamicPopup,
    msGridEditor,
    MsTour,
  },
  extends: baseDetailVoucher,
  name: 'BUPlanWithdrawCashDetail',

  setup: props => {
    const titleCode = 'detail_popup_buplanwithdrawcashdetail';
    const {proxy} = getCurrentInstance();
    const module = ModuleBuPlanWithDraw;
    const refType = ref(RefType.BUPlanWithdrawCash);
    let layoutTagDetail = ref('BUPlanwithdrawCashDetail');
    const currentLayout = ref('BUPlanwithdrawCashDetail');
    proxy._gridDetails = {BuPlanWithDrawDetails: 'refDetail'};
    const {extendFilter} = usefilterActionCombo();
    const quickAddMultiItems = ref([
      {
        valueField: 'CustomerVendorDetail',
        displayField: 'Khách hàng, nhà cung cấp',
      },
      {
        valueField: 'EmployeeDetail',
        displayField: 'Cán bộ',
      },
    ]);
    /**
     * Cấu hình ref grid để base đọc
     * NCPHUOC 29/03/2022
     */
    onMounted(() => {
      proxy._defaultRow = 5;
    });

    /**
     * Lưu lại ref_no trước khi update phục vụ cập nhật lại refno_finance màn hình InvoiceBot_List
     * HMDUC2 02/01/2023
     */
    const refNoBeforeUpdate = ref('');

    // Khởi tạo các func và các biến
    const {
      toggleAbove,
      buttonPrints,
      toggleAboveHandler,
      comboboxDataRemote,
      budgetSourceComboConfig,
      budgetChapterComboConfig,
      budgetSubKindItemComboConfig,
      budgetItemComboConfig,
      budgetSubItemComboConfig,
      projectComboConfig,
      accountingObjectComboConfig,
      activityComboConfig,
      statisticComboConfig,
      bankAccountComboConfig,
      accountComboConfig2,
      contractComboConfig,
      topicComboConfig,
      TaskComboConfig,
      budgetProvideComboConfig,
      budgetDetailItemComboConfig,
      fundStructureComboConfig,
      typeOfFundComboConfig,
      budgetKindItemComboConfig,
      submitQuickAdd,
      comboboxLoadData,
    } = useBUPlanWithdrawDetailDataCommon();

    const {
      onAccountingObjectComboboxLoadData,
      onBankInfoComboboxLoadData,
      onProjectCommonComboboxLoadData,
      projectExpenseComboConfig,
    } = useInitActionCombo(comboboxDataRemote, comboboxLoadData);

    const {buttonUtilities} = useBUPlanWithdrawCashDetailData();
    // Cập nhật lại tổng tiền khi xóa dòng dữ liệu chi tiết
    const {
      changeDataBusinessCommon,
      defaultData,
      getDataDefault,
      toggleAboveHandlerGrid,
      bindDefaultData,
      onGridStyleColumn,
      onClickCKC,
      copyDownRow,
      copyActionClick,
      copyDownRowExtend,
    } = useActionGridEditor(proxy);

    const {selectedProject, selectedBankBUPlan, selectedAccountingObject, onBlurActionDatePicker} = useInforCommons();

    const {
      clickItemHandleCommon,
      validateGrid,
      focusFirstError,
      validateComponents,
      showErrorUnPosted,
      validateGenerateVoucherPosted,
    } = useBUPlanWithdrawCommon();

    // Khởi tạo column cho dropdown của combobox
    const {projectColumns, accountColumns, currencyColumns} = useComboboxColumns();
    const onStateBankComboboxLoadData = (payload, row, column) => {
      let ors = [{Field: 'inactive', Operator: 'NULL'}];
      let extend = [{Field: 'inactive', Value: false, Ors: ors}];
      payload.filter = extendFilter(payload.filter, extend);
      payload.sort = 'state_bank_code';
      comboboxLoadData(payload, stateBankAPI, comboboxDataRemote, column.dataField);
    };
    // config columns combo
    const stateBankComboConfig = {
      data: comboboxDataRemote,
      columns: [
        {
          title: 'Mã ngân hàng',
          dataField: 'state_bank_code',
          width: 120,
          filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
        },
        {
          title: 'Tên ngân hàng',
          dataField: 'state_bank_name',
          width: 480,
          filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        },
      ],
      displayField: 'state_bank_name',
      valueField: 'state_bank_code',
      quickSearch: 'StateBankQuickSearch',
      queryMode: 'remote',
      dropdownWidth: 600,
      comboboxLoadData: onStateBankComboboxLoadData,
    };

    const {cacheAccountDebitCombo, cacheAccountCreditCombo} = useCacheAccountComboConfig();
    cacheAccountDebitCombo.modelValueField = 'debit_account';
    cacheAccountCreditCombo.modelValueField = 'credit_account';
    const {cacheBudgetSourceComboConfig} = useCacheBudgetSourceComboConfig();
    const {cacheBudgetChapterComboConfig} = useCacheBudgetChapterComboConfig();
    const {cacheBudgetKindItemComboConfig, cacheBudgetSubKindItemComboConfig} = useCacheBudgetKindItemComboConfig();
    const {
      cacheBudgetItemComboConfig,
      cacheBudgetSubItemComboConfig,
      cacheBudgetDetailItemComboConfig,
    } = useCacheBudgetItemComboConfig();
    const {cacheProjectComboConfig, projectCombo} = useCacheProjectComboConfig();
    const {cacheActivityComboConfig} = useCacheActivityComboConfig();
    const {cacheStatisticComboConfig} = useCacheStatisticComboConfig();
    const {cacheBankInfoComboConfig, bankInfoCombo} = useCacheBankInfoComboConfig();
    const {accountingObjectCombo} = useCacheAccountingObjectComboConfig();
    const {cacheContractComboConfig} = useCacheContractComboConfig();
    const {cacheTopicComboConfig} = useCacheTopicComboConfig();
    const {cacheTaskComboConfig} = useCacheTaskComboConfig();
    const {cacheBudgetProvideComboConfig} = useCacheBudgetProvideComboConfig();
    const {cacheFundStructureComboConfig} = useCacheFundStructureComboConfig();
    const {cacheFundComboConfig} = useCacheFundComboConfig();
    const {cacheBudgetFeesComboConfig} = useCacheBudgetFeesComboConfig();

    // Cấu hình các field của grid
    const propsData = {
      budget_source_name: cacheBudgetSourceComboConfig,
      budget_chapter_code: cacheBudgetChapterComboConfig,
      budget_sub_kind_item_code: cacheBudgetSubKindItemComboConfig,
      budget_item_code: cacheBudgetItemComboConfig,
      budget_sub_item_code: cacheBudgetSubItemComboConfig,
      project_code: cacheProjectComboConfig,
      accounting_object_code: accountingObjectComboConfig,
      activity_name: cacheActivityComboConfig,
      statistic_code: cacheStatisticComboConfig,
      bank_account: cacheBankInfoComboConfig,
      contract_no: cacheContractComboConfig,
      topic_code: cacheTopicComboConfig,
      task_code: cacheTaskComboConfig,
      budget_provide_code: cacheBudgetProvideComboConfig,
      budget_detail_item_code: cacheBudgetDetailItemComboConfig,
      fund_structure_name: cacheFundStructureComboConfig,
      fund_code: cacheFundComboConfig,
      budget_kind_item_code: cacheBudgetKindItemComboConfig,
      project_expense_code: projectExpenseComboConfig,
      rowAction: ['Insert', 'Delete'],
      inv_no: {
        maxLength: 20,
      },
      org_ref_no: {
        maxLength: 200,
      },
      description: {
        maxLength: 255,
      },
    };

    const subSystemCode = proxy.$ms.constant.SubSystemCode.BuPlanWithDraw;

    //Param dùng cho form tìm nhanh
    const quickSearchParam = reactive({
      Project: {
        isFilter: true,
        filterFunc: x => x.inactive == false && !x.is_parent && x.object_type == 1,
      },
      AccountingObject: {
        titleSearch: 'đối tượng',
        payload: {
          sort: 'is_employee,accounting_object_code',
        },
        module: 'accountingObject',
        idField: 'accounting_object_id',
      },
    });

    /**
     * Custom gọi hàm sinh dữ liệu
     * NVTUAN1 22.07.2022
     */
    function customVoucherLoadData(result) {
      if (
        proxy._formParam &&
        proxy._formParam.data &&
        proxy._formParam.data.IsGenerateData &&
        (proxy.editMode === proxy.$ms.constant.FormState.Add || proxy.editMode === proxy.$ms.constant.FormState.Edit)
      ) {
        Object.assign(result, {
          Id: proxy._formParam.data.ref_id,
          ParamModeAdd: JSON.stringify({
            RefTypeKey: proxy.$ms.constant.RefType.BUPlanWithdrawCash,
            VoucherRefType: proxy._formParam.voucherRefType,
          }),
          IsSyncData: proxy._formParam.data.IsSyncData,
          action: 'DataVoucher',
        });
      } else {
        proxy.super('customVoucherLoadData', baseDetailVoucher, result);
      }
    }

    /**
     * Lấy dữ liệu chuyển khoản kho bạc
     * NXCHIEN 28.04.2022
     */
    async function getDataCAReceiptPlanWithdraw(data) {
      if (data.relation_ref_id) {
        let payload = {id: data.relation_ref_id};
        try {
          return await cAReceiptAPI.getEdit(payload);
        } catch {
          return null;
        }
      }

      return null;
    }
    /**
     * Lấy layout template
     * tbngoc 19.07.2022
     */
    const getConfigLayout = () => {
      return {
        layouts: [{tag: 'BUPlanwithdrawCashDetail', name: 'Chi tiết'}],
      };
    };

    /**
     * Sinh dữ liệu sau khi validate
     * tbngoc 22.01.2024
     */
    function generateVoucherAfterValidate() {
      // Sinh chứng từ
      let details = proxy.model;
      details.IsSyncData = true;
      popupUtil.show('CAReceiptPlanWithdrawDetail', {
        mode: proxy.$ms.constant.FormState.Edit,
        id: proxy.model.relation_ref_id,
        data: details,
        options: {
          submit: data => {
            proxy.view({
              id: proxy.model.ref_id,
              mode: proxy.$ms.constant.FormState.View,
            });
          },
        },
      });
    }
    /**
     * Action click button Tiện ích
     * NXCHIEN 13.04.2022
     */
    const clickItemHandle = async item => {
      switch (item.command) {
        case proxy.$ms.constant.Command.Delete:
          proxy.delete(proxy.model);
          break;
        case proxy.$ms.constant.Command.ShowCAReceipt:
          let details = proxy.model;
          details.IsGenerateData = true;
          let dataCAReceipt = await getDataCAReceiptPlanWithdraw(details);
          if (dataCAReceipt) {
            // check quyền Sửa (vqphong - 14/12/2022)
            proxy.checkActionPermissionAlert(
              proxy.$ms.constant.Permission.Edit,
              proxy.$ms.constant.SubSystemCode.CAReceipt,
            );
            showConfirm(
              `Bạn có muốn đồng bộ các thông tin đã cập nhật trên <span class="color-green">Giấy rút</span> với phiếu thu số <span class="color-green">${proxy.$ms.commonFn.processXssValue(
                dataCAReceipt.ref_no,
              )}</span> không?`,
              `Đồng bộ chứng từ`,
            ).then(async answer => {
              switch (answer) {
                case true:
                  // Kiểm tra xem dữ liệu có lỗi không
                  const valid = await validateGenerateVoucherPosted(cAReceiptAPI, dataCAReceipt);
                  if (valid) {
                    // Sinh chứng từ
                    details.IsSyncData = true;
                    popupUtil.show('CAReceiptPlanWithdrawDetail', {
                      mode: proxy.$ms.constant.FormState.Edit,
                      id: proxy.model.relation_ref_id,
                      data: details,
                      options: {
                        submit: data => {
                          proxy.view({
                            id: proxy.model.ref_id,
                            mode: proxy.$ms.constant.FormState.View,
                          });
                        },
                      },
                    });
                  }
                  return;
                case false:
                  return;
              }
            });
          } else {
            await buPlanWithDrawAPI.deleteRefRelationId({
              ref_id: proxy.model.ref_id,
            });
            // check quyền Thêm (vqphong - 14/12/2022)
            proxy.checkActionPermissionAlert(
              proxy.$ms.constant.Permission.Add,
              proxy.$ms.constant.SubSystemCode.CAReceipt,
            );
            popupUtil.show('CAReceiptPlanWithdrawDetail', {
              mode: proxy.$ms.constant.FormState.Add,
              data: details,
              options: {
                submit: data => {
                  proxy.view({
                    id: proxy.model.ref_id,
                    mode: proxy.$ms.constant.FormState.View,
                  });
                },
              },
            });
          }
          return;
      }
      // Không thì gọi vào base
      clickItemHandleCommon(item);
      proxy.pushTrans(item.command);
    };

    /**
     * Click button sửa
     * NXCHIEN 05.04.2022
     */
    async function onEditEvent() {
      // check quyền Sửa (vqphong - 12/12/2022)
      proxy.checkActionPermissionAlert(proxy.$ms.constant.Permission.Edit);

      let dataCAReceipt = await getDataCAReceiptPlanWithdraw(proxy.model);

      if (dataCAReceipt) {
        showConfirm(
          `Giấy rút dự toán hiện thời đã sinh Phiếu thu số <span class="color-green">${proxy.$ms.commonFn.processXssValue(
            dataCAReceipt.ref_no,
          )}</span>, ngày <span class="color-green">${moment(dataCAReceipt.ref_date).format(
            'DD/MM/YYYY',
          )}</span>. Bạn có thực sự muốn sửa <span class="color-green">Giấy rút</span> này không?`,
          `Sửa Giấy rút`,
        ).then(answer => {
          switch (answer) {
            case true:
              proxy.setFormMode(proxy.$ms.constant.FormState.Edit);
              break;
            case false:
              break;
          }
        });
      } else {
        await buPlanWithDrawAPI.deleteRefRelationId({
          ref_id: proxy.model.ref_id,
        });
        proxy.setFormMode(proxy.$ms.constant.FormState.Edit);
      }
    }
    /**
     * Override sau khi lưu thành công: Hỏi Sinh chứng từ hoặc cập nhật chứng từ
     * NXCHIEN 01.04.2022
     * Modified NVTUAN1 09.08.2022: Sửa lại logic cảnh báo khi sinh
     */
    async function afterSubmitModeView(result, param) {
      // Xử lý sau khi cất chứng từ dqdat1 02.11.2023
      if (proxy._formParam && proxy._formParam.dataInbot && proxy._formParam.dataInbot.ListInvoiceInbot?.length > 0) {
        //Update lại hạch toán màn hình danh sách
        let payload = {
          ids: proxy._formParam.dataInbot.ListInvoiceInbot,
          isPosted: true,
          refNo: result.ref_no,
          // HMDUC2: Thêm biến phục vụ cập nhật refno_finance ngoài ds invoicebot_list
          isUpdatePosted: true,
          refNoBeforeUpdate: JSON.parse(proxy.refNoBeforeUpdate),
        };
        proxy.$store.dispatch('moduleInvoiceBot/updatedPosted', payload);
      }

      if (proxy._formParam && proxy._formParam.data && proxy._formParam.data.IsGenerateData) {
        proxy.super('afterSubmitModeView', baseDetailVoucher, result, param);
        return;
      }

      let details = proxy.model;
      details.IsGenerateData = true;
      details.BuPlanWithDrawDetails = proxy.$refs.refDetail.datax;

      //Nếu có phiếu thu, chứng từ được sinh rồi thì show cảnh báo cập nhật
      let dataTrans = await getDataCAReceiptPlanWithdraw(proxy.model);
      if (dataTrans) {
        proxy.checkActionPermissionAlert(
          proxy.$ms.constant.Permission.Edit,
          proxy.$ms.constant.SubSystemCode.CAReceipt,
        );
        showConfirm(
          `Bạn có muốn đồng bộ các thông tin đã cập nhật trên <span class="color-green">Giấy rút</span> với phiếu thu số <span class="color-green">${proxy.$ms.commonFn.processXssValue(
            dataTrans.ref_no,
          )}</span> không?`,
          'Đồng bộ chứng từ',
        ).then(async answer => {
          switch (answer) {
            case true:
              // Kiểm tra xem dữ liệu có lỗi không
              const valid = await validateGenerateVoucherPosted(cAReceiptAPI, dataTrans);
              if (valid) {
                details.IsSyncData = true;
                popupUtil.show('CAReceiptPlanWithdrawDetail', {
                  mode: proxy.$ms.constant.FormState.Edit,
                  id: proxy.model.relation_ref_id,
                  data: details,
                  options: {
                    submit: data => {
                      proxy.view({
                        id: proxy.model.ref_id,
                        mode: proxy.$ms.constant.FormState.View,
                      });
                    },
                  },
                });
              }
              break;
            case false:
              break;
          }
        });
      }
      //Nếu chưa được sinh phiếu thu, chứng từ thì mới sinh
      else {
        proxy.checkActionPermissionAlert(proxy.$ms.constant.Permission.Add, proxy.$ms.constant.SubSystemCode.CAReceipt);
        generateVoucher(details);
      }

      proxy.super('afterSubmitModeView', baseDetailVoucher, result, param);
    }
    /**
     * Enable Button Delete
     *
     */
    const disabledDelete = computed(() => {
      return proxy.editMode != proxy.$ms.constant.FormState.View || proxy.model.is_posted;
    });
    /**
     * Hàm sinh dữ liệu phiếu thu, chứng từ
     * NVTUAN1 09.08.2022
     * MODIFIED BY NBTIN - Sửa bug 281007: Bỏ tick "Hiển thị thông báo sinh Phiếu thu hoặc Chứng từ chuyển khoản khi lập Giấy rút dự toán"
     */
    function generateVoucher(details) {
      //Biến check xem có tích vào option "Không hiển thị lần sau" của message sinh phiếu thu, chứng từ khi lập giấy rút
      let isShowMessageGenerateInvoiceNextTime = proxy.$ms.commonFn.getLocalStorage(
        proxy.$ms.constant.StorageKey.IsShowMessageGenerateInvoiceNextTime,
      );

      //Lấy ra giá trị boolean của cờ check
      isShowMessageGenerateInvoiceNextTime = String(isShowMessageGenerateInvoiceNextTime) !== 'false';

      //Biến lưu giá trị của option "Hiển thị thông báo sinh Phiếu thu hoặc Chứng từ chuyển khoản khi lập Giấy rút dự toán"
      let isShowMessageGenerateInvoice = true;

      //Cập nhật lại biến isShowMessageGenerateInvoice theo giá trị trong dbOptions
      if (proxy.dbOptions && typeof proxy.dbOptions === 'object') {
        isShowMessageGenerateInvoice = proxy.dbOptions.IsShowMessageGenerateInvoice;
      }

      //Khai báo hàm sinh phiếu thu, chứng từ
      let callBackGenerate = () => {
        popupUtil.show('CAReceiptPlanWithdrawDetail', {
          mode: proxy.$ms.constant.FormState.Add,
          id: proxy.model.relation_ref_id,
          data: details,
          options: {
            submit: data => {
              proxy.view({
                id: proxy.model.ref_id,
                mode: proxy.$ms.constant.FormState.View,
              });
            },
          },
        });
      };

      //Check theo tùy chọn trước. Nếu trong tùy chọn có tích "Hiển thị thông báo sinh Phiếu thu hoặc Chứng từ chuyển khoản khi lập Giấy rút dự toán" thì mới thực hiện
      if (isShowMessageGenerateInvoice) {
        //Kiểm tra xem đã tích chọn "Không hiển thị lại lần sau" chưa
        if (isShowMessageGenerateInvoiceNextTime) {
          showConfirmWithDontShowAgain(
            'Bạn có muốn sinh <span class="color-green">Phiếu thu</span> không?',
            'Sinh chứng từ',
            'Không hiển thị lần sau',
          ).then(async answer => {
            switch (answer.answer) {
              case true:
                callBackGenerate();

                //Nếu nhấn Có và tích chọn "Không hiển thị lại lần sau"
                if (answer.IsShowMessage === false) {
                  // Lưu thêm cờ IsShowMessageGenerateInvoiceNextTime vào cache
                  proxy.$ms.commonFn.setLocalStorage(
                    proxy.$ms.constant.StorageKey.IsShowMessageGenerateInvoiceNextTime,
                    false,
                  );
                  // Lưu thêm cờ IsAutoGenerateVoucher thể hiện lần sau có tự sinh hay không
                  proxy.$ms.commonFn.setLocalStorage(proxy.$ms.constant.StorageKey.IsAutoGenerateVoucher, true);
                  //Cập nhật option "Hiển thị thông báo sinh Phiếu thu hoặc Chứng từ chuyển khoản khi lập Giấy rút dự toán"
                  proxy.$store.dispatch(`${ModuleDbOption}/updateDbOptions`, {
                    IsShowMessageGenerateInvoice: false,
                  });
                }
                break;
              case false:
                //Nếu nhấn Không và tích chọn "Không hiển thị lại lần sau" thì cập nhật lại giá trị của key IsShowMessageGenerateInvoice = false trong dbOptions
                if (answer.IsShowMessage === false) {
                  //Cập nhật luôn giá trị vào store
                  proxy.dbOptions.IsShowMessageGenerateInvoice = false;

                  //Xóa cờ check "Không hiển thị lần sau" đã lưu đi
                  proxy.$ms.commonFn.removeLocalStorage(
                    proxy.$ms.constant.StorageKey.IsShowMessageGenerateInvoiceNextTime,
                  );
                  //Xóa cờ cờ IsAutoGenerateVoucher thể hiện lần sau có tự sinh hay không
                  proxy.$ms.commonFn.removeLocalStorage(proxy.$ms.constant.StorageKey.IsAutoGenerateVoucher);
                  //Xóa tên chứng từ đang mặc định sinh ở Rút dự toán chuyển khoản lương, bảo hiểm
                  proxy.$ms.commonFn.removeLocalStorage(proxy.$ms.constant.StorageKey.FormDetailGenerateInvoiceName);

                  //Cập nhật option "Hiển thị thông báo sinh Phiếu thu hoặc Chứng từ chuyển khoản khi lập Giấy rút dự toán"
                  proxy.$store.dispatch(`${ModuleDbOption}/updateDbOptions`, {
                    IsShowMessageGenerateInvoice: false,
                  });
                }
                break;
              default:
                break;
            }
          });
        } else {
          callBackGenerate();
        }
      } else {
        //Biến check xem có tích vào option "Không hiển thị lần sau" của message sinh phiếu thu, chứng từ khi lập giấy rút
        let isAutoGenerateVoucher = proxy.$ms.commonFn.getLocalStorage(
          proxy.$ms.constant.StorageKey.isAutoGenerateVoucher,
        );
        if (isAutoGenerateVoucher) {
          callBackGenerate();
        }
      }
    }

    /**
     * Override để lấy thêm dữ liệu chứng từ khi mở form và gán giá trị mặc định 1 số trường
     * NXCHIEN 06.04.2022
     */
    function bindData(data) {
      if (data.ref_id || proxy._formParam.mode == proxy.$ms.constant.FormState.Add) {
        data.cash_withdraw_type_id = data.cash_withdraw_type_id || proxy.$ms.constant.CashWithDrawType.Expense; // mặc định Thực chi (6)

        data.currency_code = data.currency_code || proxy.$t('i18nEnum.Currency.VND');
        data.exchange_rate = data.exchange_rate || 1;
        data.total_amount = data.total_amount || 0;

        currencyCode.value = data.currency_code;

        data.posted_date = data.posted_date || proxy.postedDate;
        data.ref_date = data.ref_date || proxy.postedDate;

        data.showFrom = 'BUPlanWithdrawCashDetail';

        proxy.super('bindData', baseDetailVoucher, data);
        if (proxy.viewing) {
          stepsDynamic.value = steps.value.filter(x => x.state.includes('save') || x.state.includes('default'));
        } else {
          stepsDynamic.value = steps.value.filter(x => x.state.includes('edit') || x.state.includes('default'));
        }
        // DTQUOC 06.10.2023 - Gán lại giá trị cho dữ liệu khi lập nhanh từ bảng kê chứng từ thanh toán
        if (
          proxy.param.data != null &&
          proxy.param.mode != 0 &&
          proxy.param.mode != 4 &&
          (proxy.param.data.cash_withdraw_type_id == CashWithDrawType.EstimateAdvance ||
            proxy.param.data.cash_withdraw_type_id == CashWithDrawType.EstimateNotYetAdvance)
        ) {
          getDataBUPlanWithDraw(proxy.param.data);
        }

        // DTQUOC 22.11.2023 - Gán lại giá trị cho dữ liệu khi lấy thông tin từ hóa đơn
        if (
          proxy._formParam.data &&
          (proxy._formParam.data?.name == 'ViewDebtInvoiceACTPopup' ||
            proxy._formParam.data?.name == 'NotiSystemPopup' ||
            proxy._formParam.data?.name == 'FinancialInvoiceNotiPopup')
        ) {
          getDataBUPlanWithDrawByInv(proxy._formParam.data);
        }

        proxy.refNoBeforeUpdate = JSON.stringify(data?.ref_no);
      }
    }

    /**
     * Gán lại giá trị cho dữ liệu khi lập nhanh từ bảng kê chứng từ thanh toán
     * DTQUOC 06.10.2023
     */
    function getDataBUPlanWithDraw(data) {
      proxy.model.BuPlanWithDrawDetails = data.BuPlanWithDrawDetails;
      proxy.model.project_code = proxy.param.data.project_code;
      proxy.model.project_name = proxy.param.data.project_name;
      proxy.model.bank_account = null;
      proxy.model.accounting_object_code = null;
      proxy.model.bank_name = null;
      proxy.model.cash_withdraw_type_id = proxy.param.data.cash_withdraw_type_id;
      proxy.model.journal_memo = proxy.param.data.description;

      // Set lại một số trường dữ liệu
      proxy.param.data.BuPlanWithDrawDetails.forEach(item => {
        item.ref_detail_id = null;
        item.ref_id = proxy.model.ref_id;
        item.ref_type = proxy.model.ref_type;
        item.state = 1; // Thêm mới
      });
    }

    /**
     * gán dữ liệu từ thông tin hóa đơn
     * DTQUOC 21.11.2023
     */
    function getDataBUPlanWithDrawByInv(data) {
      // CTMT
      proxy.model.project_code = null;
      proxy.model.project_name = null;
      // Tài khoản số
      proxy.model.bank_account = null;
      proxy.model.bank_name = null;
      //người lĩnh tiền
      proxy.model.accounting_object_id = null;
      proxy.model.accounting_object_code = null;
      proxy.model.accounting_object_name = null;
      // diễn giải
      var explain = `Mã QHNS: ${proxy.dbOptions.CompanyCode} ; Số HĐ: `;
      data.forEach(element => {
        explain += element.inv_no + ', ';
      });
      explain = explain.slice(0, -2);
      explain += '; Số điện thoại người thanh toán:... ; Thanh toán tiền mua phần mềm:...';
      proxy.model.journal_memo = explain;
      // loại tiền
      proxy.model.currency_code = proxy.model.currency_code || proxy.$t('i18nEnum.Currency.VND');
      // tổng tiền của từng hóa đơn
      var total = [];
      data.forEach(element => {
        let sum = 0;
        let result = element.Details.filter(x => x.type != 3);
        result.forEach(e => {
          sum += e.unit_price;
        });
        let ob = {inv_no: element.inv_no, amount: sum};
        total.push(ob);
      });

      // nội dung thanh toán và số tiền
      var arr = [];
      // mảng các hóa đơn có chiết khấu thương mại
      var arr_discount_commerce = [];
      data.forEach(element => {
        var object_discount_commerce = element.Details.find(i => i.type == 3);
        if (object_discount_commerce != null && object_discount_commerce.length != 0) {
          arr_discount_commerce.push({inv_no: element.inv_no, total_discount: object_discount_commerce.unit_price});
        }
        let result = element.Details.filter(x => x.type != 3);
        result.forEach(e => {
          e.description =
            'Số hóa đơn: ' +
            element.inv_no +
            ' - Ngày hóa đơn: ' +
            moment(element.inv_date).format('DD/MM/YYYY') +
            ' - Tên hàng hóa, dịch vụ: ' +
            e.inventory_item_name;
          e.inv_no = element.inv_no;
          e.inv_date = element.inv_date;
          arr.push(e);
        });
      });

      arr.forEach(item => {
        item.ref_detail_id = null;
        item.ref_id = proxy.model.ref_id;
        item.ref_type = proxy.model.ref_type;
        item.state = 1;
        // Nguồn
        item.budget_source_id = proxy.dbOptions.DefaultBudgetSourceID;
        item.budget_source_name = proxy.dbOptions.DefaultBudgetSourceName;

        // chương
        item.budget_chapter_id = proxy.dbOptions.DefaultBudgetChapterId;
        item.budget_chapter_code = proxy.dbOptions.DefaultBudgetChapterCode;
        // loại
        item.budget_kind_item_id = proxy.dbOptions.DefaultBudgetKindItemId;
        item.budget_kind_item_code = proxy.dbOptions.DefaultBudgetKindItemCode;
        // khoản
        item.budget_sub_kind_item_id = proxy.dbOptions.DefaultBudgetSubKindItemId;
        item.budget_sub_kind_item_code = proxy.dbOptions.DefaultBudgetSubKindItemCode;

        // số tiền
        let amount = item.quantity * item.unit_price,
          tax_amount = item.tax_amount,
          discount_amount = item.discount_amount,
          discount_amount_commerce_total = 0,
          amount_total = 0;
        let ob = total.find(i => i.inv_no == item.inv_no);
        amount_total = ob?.amount;
        let ob_commerce = arr_discount_commerce.find(i => i.inv_no == item.inv_no);
        if (ob_commerce != null) {
          discount_amount_commerce_total = ob_commerce.total_discount;
        }
        item.amount_oc = generateAmountByInvIsTaxRate(
          amount,
          discount_amount,
          tax_amount,
          discount_amount_commerce_total,
          amount_total,
        );

        item.amount = item.amount_oc;
        // đơn giá
        item.unitprice = commonFunction.roundDecimalDbOption(
          proxy.$ms.constant.DbOptionKey.CurrencyUnitPriceDigits,
          item.amount_oc / item.quantity,
        );
      });
      proxy.model.BuPlanWithDrawDetails = arr;
    }

    /**
     * hàm sinh số tiền tương ứng với từng hàng hóa, dịch vụ có thuế suất
     * @param {amount} - thành tiền chưa trừ chiết khấu
     * @param {discount_amount} - tiền chiết khấu của mặt hàng tương ứng
     * @param {tax_rate} - thuế suất
     * @param {total_vat_amount} - tổng tiền thuế của hóa đơn
     */
    function generateAmountByInvIsTaxRate(
      amount,
      discount_amount,
      tax_amount,
      discount_amount_commerce_total,
      amount_total,
    ) {
      // Tiền chiết khấu thương mại chung của hóa đơn tính cho mặt hàng đó
      var discount_amount_commerce = 0;
      if (discount_amount_commerce_total != 0 && discount_amount_commerce_total != null) {
        discount_amount_commerce = ((amount - discount_amount) * discount_amount_commerce_total) / amount_total;
      }
      var res = Math.round(amount - discount_amount + tax_amount - discount_amount_commerce);
      return res;
    }

    /**
     * Ovrride để Gán thêm 1 số field để save
     * NXCHIEN 30.03.2022
     */
    function getSaveData(mode, action) {
      let data = proxy.super('getSaveData', baseDetailVoucher, mode, action);
      if (proxy.editMode == proxy.$ms.constant.FormState.Add) {
        data.created_date = new Date();
      }
      if (
        proxy.editMode == proxy.$ms.constant.FormState.Add ||
        proxy.editMode == proxy.$ms.constant.FormState.Duplicate
      ) {
        data.is_planned = false;
      }
      if (!data.bu_commitment_request_ref_no) {
        data.bu_commitment_request_id = null;
      }
      data.ref_type = proxy.$ms.constant.RefType.BUPlanWithdrawCash;
      data.ref_type_name = proxy.$t('i18nEnum.RefType.BUPlanWithdrawCash');
      data.cash_withdraw_type_name = proxy.$ms.format.formatData(data.cash_withdraw_type_id, {
        enumName: 'CashWithDrawType',
        formatType: proxy.$ms.constant.FormatType.Enum,
      });
      data.BuPlanWithDrawDetails.forEach(x => {
        x.ref_type = data.ref_type;
      });
      // nthien4 28/08/23 bsung tham số để check thêm khi online hay offline
      data.isSaveOffline = proxy?.offlineReady;
      if (data.isSaveOffline && !data.state) {
        data.state = proxy.$ms.constant.FormState.Add;
      }
      return data;
    }

    //#endregion

    //#region config ẩn hiện cột và sự kiện liên quan đến combo Loại tiền
    const {
      onCurrencyComboboxLoadData,
      selectCurrency,
      onActionBlur,
      totalAmountComputed,
      assignValueCurrency,
      currencyCode, // Bổ sung để watch loại tiền
      isFirst, // không watch khi load lên lần đầu
    } = useCurrencyCombo(
      comboboxDataRemote,
      comboboxLoadData,
      proxy,
      'BuPlanWithDrawDetails',
      null,
      null,
      customSelectCurrency,
    );

    /**
     * custom hiển thị thêm cột quy đổi trên grid
     * NXCHIEN 12.06.2022
     */
    function customColumns(columns) {
      isFirst.value = false;
      if (proxy.model.currency_code && proxy.model.currency_code != proxy.$t('i18nEnum.Currency.VND')) {
        columns.forEach(item => {
          if (item.dataField == 'amount') {
            item.visible = true;
          } else if (item.dataField == 'amount_oc') {
            item.formatType = proxy.$ms.constant.FormatType.AmountOC;
          }
        });
      }
    }
    //#endregion
    /**
     * Sự kiện chọn loại tiền
     * tbngoc 29.08.2022
     */
    function customSelectCurrency() {
      if (proxy.model && proxy.model.BuPlanWithDrawDetails) {
        proxy.model.BuPlanWithDrawDetails.forEach(item => {
          if (item.quantity > 0) {
            item.unitprice = item.amount / item.quantity;
          }
        });
      }
    }
    /**
     * Sự kiện sau khi thay đổi tỷ giá
     */
    function customActionBlur() {
      customSelectCurrency();
    }

    /**
     * Update value khi sửa 1 field trong grids
     * NXCHIEN 13.04.2022
     */
    const changeDataBusiness = ($grid, col, rowIndex, metaData, callbackUpdateRow) => {
      const {dataField} = col;
      const {tracking} = metaData;
      let newUnitPrice;
      let rowData = $grid.dataView[rowIndex]; //lấy ra dữ liệu của hàng đang sửa
      let quantity = rowData.quantity ?? 0;
      changeDataBusinessCommon($grid, col, rowIndex, metaData, callbackUpdateRow, dataField, tracking);
      // Custom thêm thì switch case ở đây.
      
      switch (dataField) {
        // đơn giá
        case 'unitprice':
          let unitPrice = tracking.newVal || 0;
          let exchangeRate = proxy.model.exchange_rate || 1;
          callbackUpdateRow({
            amount_oc: (quantity * unitPrice).toRound(), 
            amount: (quantity * unitPrice * exchangeRate).toRound() }, rowIndex);
          break;
      }
    };

    /**
     * Override từ base
     * Cập nhật danh sách bên ngoài sau khi xóa bản ghi liên quan bên trong màn hình chi tiết
     * @param {*} param
     * NVTUAN1 26.07.2022
     */
    function afterDeleteRelation(param) {
      const me = this;
      if (param && Array.isArray(param) && param.length) {
        let dataParam = param[0];
        let moduleValue = '';
        switch (dataParam.RefType) {
          //Phiếu thu rút dự toán nhập quỹ tiền mặt
          case me.$ms.constant.RefType.CAReceiptPlanWithdraw:
            moduleValue = ModuleCAReceipt;
            break;
          default:
            break;
        }

        if (moduleValue) {
          me.$store.dispatch(`${moduleValue}/updateAfterDeleteRelation`, param);
        }
      }
    }
    const bankColumns = [
      {
        title: 'Số tài khoản',
        dataField: 'bank_account',
        width: 180,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên ngân hàng',
        dataField: 'bank_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      },
    ];

    /**
     * event khi chuyển tab
     */
    const changeRadioType = () => {
      proxy.$nextTick(() => {
        proxy.resetValidate();
        //focus first control
        setTimeout(function () {
          proxy.focusFirstControl();
        }, 300);
      });
    };
    const stepsDynamic = ref([]);
    /**
     * Dữ liệu step
     */
    const steps = ref([
      {
        target: '.step-1',
        header: {
          title: 'Chức năng Hướng dẫn',
        },
        state: ['default'],
        content: 'Xem hướng dẫn nhanh các thao tác trên màn hình chứng từ',
      },
      {
        target: '.step-2',
        header: {
          title: 'Phím tắt',
        },
        state: ['default'],
        content: 'Xem danh sách các phím tắt để thao tác nhanh trên phần mềm',
      },
      {
        target: '.step-3',
        header: {
          title: 'Tùy chỉnh giao diện',
        },
        state: ['default'],
        content: 'Thực hiện tùy chỉnh giao diện chứng từ theo nhu cầu',
      },
      {
        target: '.step-4',
        header: {
          title: 'Trợ giúp',
        },
        state: ['default'],
        content: 'Xem tài liệu hướng dẫn chi tiết nghiệp vụ',
      },

      {
        target: '.ms-tbody td.budget_sub_item_code',
        dataField: 'budget_sub_item_code',
        header: {
          title: 'Nhập Tiểu mục',
        },
        scroll: {
          inline: 'auto',
          marginH: 80,
        },
        state: ['edit'],
        content: `Nhập thông tin Tiểu mục theo từng nội dung rút dự toán chi tiết`,
      },

      {
        target: '.ms-tbody .row-editor-action.insert',
        header: {
          title: 'Thêm dòng',
        },
        scroll: {},
        state: ['edit'],
        content: 'Thêm nội dung rút dự toán tiền mặt',
      },

      {
        target: '.ms-tbody .row-editor-action.delete',
        header: {
          title: 'Xóa dòng',
        },
        scroll: {},
        state: ['edit'],
        content: 'Xóa nội dung rút dự toán tiền mặt',
      },

      {
        target: '.step-close',
        header: {
          title: 'Chức năng',
        },
        state: ['edit'],
        content: `Thực hiện Cất để lưu chứng từ`,
      },
      {
        target: '.step-5-save',
        header: {
          title: 'Tiện ích',
        },
        state: ['save'],
        content: 'Tùy chọn các chức năng khác của chứng từ như: Thêm chứng từ, Thêm mới từ chứng từ hiện thời,...',
      },
      {
        target: '.step-6-save',
        header: {
          title: 'Chức năng In',
        },
        state: ['save'],
        content: 'Lựa chọn chứng từ để in hoặc thiết lập tùy chọn in theo lô',
      },
      {
        target: '.step-7-save',
        header: {
          title: 'Chức năng Xóa',
        },
        state: ['save'],
        content: `Xóa chứng từ hiện thời`,
      },
      {
        target: '.step-close',
        header: {
          title: 'Sửa',
        },
        state: ['save'],
        content: `Sửa chứng từ hiện thời`,
      },
    ]);

    onMounted(() => {
      /** Dữ liệu step binding */
      proxy.steps = computed(() =>
        steps.value.filter(x => !x.dataField || proxy.gridDetail?.columnx.some(o => o.dataField == x.dataField)),
      );
      if (proxy._formParam?.isCreateFromInbot) {
        quickSearchParam.AccountingObject.dataFromInvoiceInbot = proxy._formParam?.dataQuickAdd;
      }
    });

    /**
     * Custom diễn giải theo đơn vị
     * pqkhanh 24.02.2023
     */
    const selectedAccountingObjectBUPlanWidthDraw = ({newData}, me) => {
      selectedAccountingObject({newData}, me);
      if (newData) {
        // nếu đơn vị có tên là misa
        if (
          (proxy.editMode === proxy.$ms.constant.FormState.Add ||
            proxy.editMode === proxy.$ms.constant.FormState.Edit) &&
          proxy.model.accounting_object_name.toLowerCase().includes('misa')
        ) {
          proxy.model.journal_memo = `Mã QHNS: ${proxy.dbOptions.CompanyCode}; Số HĐ: ...; Số điện thoại người thanh toán : ....; Thanh toán tiền mua phần mềm:...`;
        }
      }
    };

    // Cập nhật lại trạng thái đã hạch toán
    // lttuan1 - 30.05.2023
    function beforeClose(e) {
      if (
        proxy.editMode !== proxy.$ms.constant.FormState.Add &&
        proxy.editMode !== proxy.$ms.constant.FormState.Duplicate
      ) {
        proxy.$store.dispatch(`${proxy.module}/updateItemMultiMaster`, {
          ref_id: proxy.model.ref_id,
          is_planned: proxy.model.is_planned,
        });
      }
      proxy.super('beforeClose', baseDetailVoucher, e);
    }

    /**
     * Lấy tên đối tượng của form
     */
    const getModuleName = () => {
      return 'Rút dự toán tiền mặt';
    };

    /**
     * nthien4 custom lại để case TH mất mạng
     */
    function saveError(error, param, action) {
      // case nếu mất mạng thì show thông báo cất thành công
      if (proxy.offlineReady) {
        // Khi mất mạng, vẫn show cất thành công
        // Chuyển mode về xem
        proxy.editMode = proxy.$ms.constant.FormState.View;
        proxy.$toast.success(proxy.$tm('i18nBaseForm.Message.SaveSuccess'));
      } else {
        proxy.super('saveError', baseDetailVoucher, error, param, action);
      }
    }

    /**
     * Lập chứng từ từ Hóa đơn xử lý đầu vào
     * dqdat1 19.10.2023
     */
    function bindDataFromInbot(data, dataInbot, dataInbotDetail, dataInbotTax) {
      Object.assign(data, dataInbot);
      data.BuPlanWithDrawDetails = [];
      dataInbotDetail.forEach(detail => {
        data.BuPlanWithDrawDetails.push(detail);
      });
    }
    /**
     * Xử lý sau khi xóa
     * dqdat1 26.10.2023
     */
    function deleteSuccess(record, result) {
      let me = proxy;
      // Xử lý sau khi cất chứng từ dqdat1 24.10.2023
      if (proxy._formParam && proxy._formParam.dataInbot && proxy._formParam.dataInbot.ListInvoiceInbot?.length > 0) {
        //Update lại hạch toán màn hình danh sách
        let payload = {
          ids: proxy._formParam.dataInbot.ListInvoiceInbot,
          isPosted: false,
          refNo: null,
          refNoDelete: record?.ref_no, // HMDUC2 02/01/2023: Lưu lại ref_no ct xóa thành công phục vụ cập nhật lại chứng từ hoạch toán invoicebot_list
        };
        proxy.$store.dispatch('moduleInvoiceBot/updatedPosted', payload);
      }

      if (proxy._formParam && proxy._formParam.data && proxy._formParam.data.IsGenerateData) {
        proxy.super('afterSubmitModeView', baseDetailVoucher, result, param);
        return;
      }
      me.super('deleteSuccess', baseDetailVoucher, record, result);
    }
    const changeTriggers = shallowRef([
      'project_code',
      'budget_source_name',
      'budget_kind_item_code',
      'budget_sub_kind_item_code',
      'budget_item_code',
      'budget_sub_item_code',
      'amount_oc',
      'unitprice',
      'quantity',
      'budget_detail_item_code',
    ]);
    /**
     * Custom tham số xóa chứng từ
     * TPNAM 28.02.2024
     */
    function getParamDeleteDetail(tempArr){
      return [...tempArr.map(({ ref_id, ref_type, ref_no }) => ({ref_id, ref_type, ref_no }))];
    }
    return {
      titleCode,
      changeTriggers,
      layoutTagDetail,
      currentLayout,
      //tên router form danh sách khi đóng sẽ quay lại
      backRouter: '/treasury/budgetplan',
      toggleAbove,
      toggleAboveHandler,
      buttonUtilities,
      buttonPrints,
      module,
      beforeClose,
      cAReceiptAPI,
      projectColumns,
      bankColumns,
      accountColumns,
      currencyColumns,

      propsData,
      comboboxDataRemote,
      comboboxLoadData,

      submitQuickAdd,
      clickItemHandle,
      afterSubmitModeView,
      onEditEvent, // sự kiện sửa
      changeDataBusiness,
      bindData, // override bind dữ liệu
      getSaveData, // Overrride lấy tham số cất dữ liệu

      //Xử lý event select combo
      selectedProject,
      selectedAccountingObject,
      selectedBankBUPlan,

      selectCurrency,
      onActionBlur,
      onCurrencyComboboxLoadData,
      onAccountingObjectComboboxLoadData,
      onBankInfoComboboxLoadData,
      onProjectCommonComboboxLoadData,

      customColumns,
      toggleAboveHandlerGrid,
      getConfigLayout,
      onClickCKC,
      quickAddMultiItems,
      customVoucherLoadData,
      totalAmountComputed,
      assignValueCurrency,
      afterDeleteRelation,
      onBlurActionDatePicker,
      currencyCode,
      customActionBlur,
      changeRadioType,
      refType,
      copyDownRow,
      copyActionClick,
      steps,
      subSystemCode,
      quickSearchParam,
      selectedAccountingObjectBUPlanWidthDraw,
      validateGrid,
      focusFirstError,
      disabledDelete,
      validateComponents,
      getModuleName,
      stepsDynamic,
      projectCombo,
      bankInfoCombo,
      accountingObjectCombo,
      saveError,
      getDataBUPlanWithDraw,
      copyDownRowExtend,
      bindDataFromInbot,
      deleteSuccess,
      getDataBUPlanWithDrawByInv,
      generateAmountByInvIsTaxRate,
      refNoBeforeUpdate,
      DBStartDateString: proxy.DBStartDateString,
      showErrorUnPosted,
      generateVoucherAfterValidate,
      getParamDeleteDetail
    };
  },

  computed: {
    ...mapGetters({
      postedDate: ModuleContext + '/PostedDate',
    }),
    offlineReady() {
      if (!this.$store.state[ModuleOfflineWork]) return false;
      return this.$store.state[ModuleOfflineWork].offlineReady;
    },
    projectCombo() {
      return this.projectCombo.sort(function (a, b) {
        return a.project_code - b.project_code;
      });
    },
    accountingObjectCombo() {
      return this.accountingObjectCombo
        ?.sort(function (a, b) {
          return a.accounting_object_code - b.accounting_object_code;
        })
        .sort(function (a, b) {
          return a.is_employee - b.is_employee;
        });
    },
  },
};
</script>

<style lang="scss">
.plan-with-draw-cash-detail {
  @import './BUPlanWithdrawDepositDetail.scss';
  .budget-plan-with-draw-detail {
    background-color: $ms-grey;
  }
  .btn {
    &.icon-button {
      background: none !important;
    }
  }

  .control-title {
    width: 107px !important;
  }
}
</style>
